import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth tokens are transported exclusively via httpOnly cookies set by the
// backend on /api/auth/login. We never read or write tokens from JS-visible
// storage (localStorage / sessionStorage) — that would expose them to XSS.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
